import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { ValidationObserver, ValidationProvider, configure, setInteractionMode } from 'vee-validate'
import './validations/basicValidations'
import './filters/filter.js'
import VueWorker from 'vue-worker'
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
Vue.use(VueWorker)
configure({
    classes: {
        invalid: 'isInputInvalid'
    }
})
setInteractionMode('aggressive')

Vue.config.productionTip = false
export const bus = new Vue()

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
